import React, {useState, useEffect} from 'react';
import {Backdrop, ModalWrapper} from './Modal.style';
import ReactDOM from "react-dom";

interface IModalProps {
    showModal: boolean;
    children: JSX.Element | JSX.Element[];
    width: number | string;
    height: number | string;
    whiteBackdrop?: boolean;
    onCloseAnimation?: Function;
}

export const Modal = ({showModal, children, width, height, whiteBackdrop = false, onCloseAnimation}: IModalProps) => {

    const [shouldRender, setShouldRender] = useState(showModal);

    const onAnimationEnd = () => {
        if (!showModal) {
            setShouldRender(false);
            onCloseAnimation && onCloseAnimation(false);
        }
    };

    useEffect(() => {
        if (showModal) {
            setShouldRender(true);
        }
    }, [showModal]);
    const modalContent = (
        <Backdrop showModal={showModal} whiteBackdrop={whiteBackdrop}>
        <ModalWrapper onAnimationEnd={onAnimationEnd} showModal={showModal} width={width} height={height}
                      onClick={event => event.stopPropagation()}>
            {children}
        </ModalWrapper>
    </Backdrop>
    );
    return (
        <>
            {shouldRender
            //@ts-ignore
                ? ReactDOM.createPortal(modalContent,document.querySelector('body'))
                : null}
        </>
    );

};
